<template>
  <div class="content" id="content-al">
    <slot></slot>
  </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>
  .content{
    overflow-y: auto;
    display: inline-block;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    vertical-align: top;
    font-size: 14px;
    background: #F1F2F6;
    padding: 24px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
  }
  .content::-webkit-scrollbar {
    width: 6px;
    height: 2px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color:rgba(144,147,153,0);
    transition: background-color .3s;
    border: none;
  }
  .content:hover::-webkit-scrollbar-thumb{
    background-color:rgba(144,147,153,.3);
  }
</style>



// WEBPACK FOOTER //
// UI/Main/index.vue